import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import MediaPickerModal from "../components/MediaPickerModal";

const EditAccount = () => {
    const [showMediaPicker, setShowMediaPicker] = useState(false);
    const [banner, setBanner] = useState("");
    return (
        <>
            <PageHeader pageTitle="Edit User" is_deploy_enable={false}>
                <button className="btn-white me-3">Discard</button>
                <button className="btn-black">
                    Update User
                </button>
            </PageHeader>

            <div className="page-container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="theme-card p-4 mb-4">
                            <div className="card-title pb-3">General Information</div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="frm-group">
                                        <label className="frm-label d-flex align-items-center">First Name</label>
                                        <input type="text" className="frm-input" placeholder="Enter first name" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="frm-group">
                                        <label className="frm-label d-flex align-items-center">Last Name</label>
                                        <input type="text" className="frm-input" placeholder="Enter last name" />
                                    </div>
                                </div>
                            </div>
                            <div className="frm-group">
                                <label className="frm-label d-flex align-items-center">Default Role</label>
                                <select className="frm-select">
                                    <option value="">Default Role</option>
                                </select>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="frm-group">
                                        <label className="frm-label d-flex align-items-center">Email</label>
                                        <input type="email" className="frm-input" placeholder="Enter email" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="frm-group">
                                        <label className="frm-label d-flex align-items-center">Phone</label>
                                        <input type="text" className="frm-input" placeholder="Enter phone" />
                                    </div>
                                </div>
                            </div>

                            <div className="frm-group">
                                <label className="frm-label d-flex align-items-center">Profile Picture</label>
                                <div
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShowMediaPicker(true)}
                                >
                                    {banner ? (
                                        <img
                                            src={banner}
                                            alt="preview"
                                            style={{
                                                minHeight: "100%",
                                                maxWidth: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                minHeight: "100%",
                                                maxWidth: "100%",
                                                background: "#f5f5f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            Upload Profile Picture
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MediaPickerModal
                show={showMediaPicker}
                onClose={() => setShowMediaPicker(false)}
                onSelect={(mediaUrl) => {
                    setBanner(mediaUrl);
                    setShowMediaPicker(false);
                }}
            />
        </>
    )
}

export default EditAccount